import DashboardLayoutSidebar from "./DashboardLayoutSidebar";
import AppBar from "~/components/AppBar";
import ExpressBanner from "~/components/ExpressBanner";
import Navbar from "~/components/Navbar";
import type { Layout } from "~/types";
import { sidebarLinks } from "~/utils/constants";

const DashboardLayout: Layout<{}> = ({ children, breadcrumbs }) => {
	return (
		<div className="flex h-screen w-screen flex-col bg-slate-100 dark:bg-slate-900/60">
			<Navbar breadcrumbs={breadcrumbs} className="shadow-none!" />

			<div className="flex flex-1 overflow-hidden">
				<DashboardLayoutSidebar />

				<div className="flex h-full w-full flex-col overflow-auto">
					<div className="flex-1">{children}</div>

					<ExpressBanner hasAppBar />
					<AppBar items={sidebarLinks} hideScrollToTop />
				</div>
			</div>
		</div>
	);
};

export default DashboardLayout;
